import React, { useEffect, useState } from "react";
import { BiPlus } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";

const EmployeeSalaryPackage = ({
  selectDatas,
  SET_COST_SHEET_HEADING,
  SET_COST_SHEET,
}) => {
  const rate_category_id = getIdByName(
    selectDatas?.rate_category,
    "Employee Salary Package"
  );
  const [totMonthlyCharges, setTotalMonthlyCharges] = useState([0]);
  const [fixedColumns, setFixedColumns] = useState([
    {
      col: "job_position_id",
      title: "ACTUAL PROFESSION",
      type: "select",
      data: selectDatas?.job_possition,
      default: true,
    },
    {
      col: "visa_profession_id",
      title: "VISA PROFESSION",
      type: "select",
      data: selectDatas?.visa_profession,
      default: true,
    },
    {
      col: "profession_level_id",
      title: "PROFESSION LEVEL",
      type: "select",
      data: selectDatas?.profession_level,
      default: true,
    },
    {
      col: "gender",
      title: "GENDER",
      type: "select",
      data: [
        {
          id: "MALE",
          name: "MALE",
        },
        {
          id: "FEMALE",
          name: "FEMALE",
        },
      ],
      default: true,
    },
    {
      col: "nationality_id",
      title: "NATIONALITY",
      type: "select",
      data: selectDatas?.nationality,
      default: true,
    },
    {
      col: "quantity",
      title: "QUANTITY",
      default: true,
    },
  ]);

  const [fixedColsRows, setFixedColsRows] = useState([
    {
      job_position_id: "",
      visa_profession_id: "",
      profession_level_id: "",
      gender: "",
      nationality_id: "",
      quantity: "0",
    },
  ]);

  const [costSheetHeadings, setCostSheetHeadings] = useState([
    {
      costSheetId: Math.random(),
      rate_category_id,
      rate_category_item_name: "Salary",
      type: "Dynamic",
      default: true,
    },
    {
      costSheetId: Math.random(),
      rate_category_id,
      rate_category_item_name:
        "Monthly Fee (each) (including NItakat, Admin and SL Service Fee) (SAR)",
      type: "Dynamic",
      default: true,
    },
  ]);

  const [costSheetRows, setCostSheetRows] = useState([
    [
      {
        rate_category_id,
        rate_category_item_name: "Salary",
        type: "Dynamic",
        cost: "0",
      },
      {
        rate_category_id,
        rate_category_item_name:
          "Monthly Fee (each) (including NItakat, Admin and SL Service Fee) (SAR)",
        type: "Dynamic",
        cost: "0",
      },
    ],
  ]);

  const addNewColumn = () => {
    const headingLen = costSheetHeadings.length; 
    const _costSheetHeadings = JSON.parse(JSON.stringify(costSheetHeadings));
    
    _costSheetHeadings.splice(headingLen-1,0,{
        costSheetId: Math.random(),
        rate_category_id,
        rate_category_item_name: "",
        type: "Dynamic",
        default: false
    })
    
    setCostSheetHeadings(_costSheetHeadings);
    
    // const tempRows = costSheetRows;
    const _costSheetRows = JSON.parse(JSON.stringify(costSheetRows));

    for (let i = 0; i < costSheetRows.length; i++) {
      _costSheetRows[i].splice(headingLen-1,0,{
        rate_category_id,
        rate_category_item_name: "",
        type: "Dynamic",
        default: false,
      });
    }
    setCostSheetRows([..._costSheetRows]);
  };

  const updateColumnName = (index, newValue) => {
    const updatedHeadings = JSON.parse(JSON.stringify(costSheetHeadings));
    updatedHeadings[index].rate_category_item_name = newValue;

    setCostSheetHeadings([...updatedHeadings]);

    const tempRows = costSheetRows;
    for (let i = 0; i < costSheetRows?.length; i++) {
      tempRows[i][index].rate_category_item_name = newValue;
    }
    setCostSheetRows([...tempRows]);
  };

  const deleteColumn = (index) => {
    const updatedColumns = costSheetHeadings?.filter((ele, ind) => {
      return ind !== index;
    });
    setCostSheetHeadings([...updatedColumns]);

    const tempRows = [...costSheetRows];
    for (let i = 0; i < costSheetRows?.length; i++) {
      let tt = tempRows[i]?.splice(index, 1);
    }
    setCostSheetRows(tempRows);
    // for(let i=0; i<fixedColsRows.length; i++){
    //     updateTotalMonthly(i,[...tempRows]);
    // }
    updateTotalMonthlyForAll(tempRows);
  };

  // Row works
  const addNewRow = () => {
    setFixedColsRows([
      ...fixedColsRows,
      {
        job_position_id: "",
        visa_profession_id: "",
        profession_level_id: "",
        gender: "",
        nationality_id: "",
        quantity: "0",
      },
    ]);
    const newRow = JSON.parse(JSON.stringify(costSheetRows[0]));
    const tempRows = costSheetRows;
    for (let i = 0; i < newRow.length; i++) {
      newRow[i].cost = 0;
    }
    tempRows.push(newRow);
    setCostSheetRows([...tempRows]);
  };

  const deleteRow = (rowIndex) => {
    if (fixedColsRows.length <= 1) return false;
    const updatedRows = fixedColsRows.filter((ele, index) => {
      return index != rowIndex;
    });
    setFixedColsRows([...updatedRows]);

    const updatedCostRows = costSheetRows.filter((ele, index) => {
      return index != rowIndex;
    });
    setCostSheetRows([...updatedCostRows]);
  };

  function updateTotalMonthlyForAll(costSheet) {
    let totalUpdate = [...totMonthlyCharges];
    for (let rowIndex = 0; rowIndex < fixedColsRows.length; rowIndex++) {
      const updatedCosts = [...costSheet];
      let sum = 0;
      for (let i = 0; i < updatedCosts[rowIndex].length; i++) {
        const cost = parseInt(updatedCosts[rowIndex][i].cost);
        if (!isNaN(cost)) {
          sum += cost;
        }
      }
      const tot = sum + parseInt((updatedCosts[rowIndex][0].cost / 100) * 2);
      totalUpdate[rowIndex] = tot;
    }
    // return totalUpdate;
    setTotalMonthlyCharges([...totalUpdate]);
  }
  function updateTotalMonthly(rowIndex, costSheet) {
    const updatedCosts = [...costSheet];
    let sum = 0;
    for (let i = 0; i < updatedCosts[rowIndex].length; i++) {
      const cost = parseInt(updatedCosts[rowIndex][i].cost);
      if (!isNaN(cost)) {
        sum += cost;
      }
    }
    const tot = sum + parseInt((updatedCosts[rowIndex][0].cost / 100) * 2);
    const totalUpdate = [...totMonthlyCharges];
    totalUpdate[rowIndex] = tot;
    setTotalMonthlyCharges([...totalUpdate]);
  }

  const handleUpdateRowProperties = (rowId, col, value, inputValue) => {
    if (!inputValue) {
      const tempRows = fixedColsRows;
      tempRows[rowId][col] = value;
      setFixedColsRows([...tempRows]);
    } else {
      const tempRows = fixedColsRows;
      tempRows[rowId][col] = value;
      setFixedColsRows([...tempRows]);
    }
    if (col === "profession_level_id") {
      const monthlyFee = getMonthlyFee(
        selectDatas,
        fixedColsRows[rowId]?.profession_level_id
      );
      const updatedCosts = JSON.parse(JSON.stringify(costSheetRows));

      // updatedCosts[rowId][updatedCosts[rowId][updatedCosts[rowId].length - 1]] =
      //   {
      //     ...updatedCosts[rowId][
      //       updatedCosts[rowId][updatedCosts[rowId].length - 1]
      //     ],
      //     cost: parseInt(monthlyFee),
      //   };
      // setCostSheetRows(updatedCosts);

      // updateTotalMonthly(rowId, updatedCosts);
      updatedCosts[rowId][costSheetHeadings.length-1] = {
        ...updatedCosts[rowId][costSheetHeadings.length-1],
        cost: parseInt(monthlyFee),
      };
      setCostSheetRows(updatedCosts);
  
      updateTotalMonthly(rowId, updatedCosts);
    }
  };

  const updateCostSheetValues = (rowIndex, costIndex, value) => {
    const updatedCostSheetRows = JSON.parse(JSON.stringify(costSheetRows));
    updatedCostSheetRows[rowIndex][costIndex].cost = value;
    setCostSheetRows(updatedCostSheetRows);
    updateTotalMonthly(rowIndex, updatedCostSheetRows);
  };

  const formatFinalData = () => {
    let finalRows = fixedColsRows;
    for (let i = 0; i < finalRows.length; i++) {
      finalRows[i].cost_sheet_heading = costSheetRows[i];
    }
    const updatedCostSheetHeadings = costSheetHeadings.map((item) => {
      const {
        default: removedDefault,
        costSheetId: removed,
        ...newItem
      } = item;
      return newItem;
    });
    SET_COST_SHEET(finalRows);
    SET_COST_SHEET_HEADING(updatedCostSheetHeadings);
  };

  useEffect(() => {
    formatFinalData();
  }, [fixedColsRows, costSheetRows]);

  return (
    <div>
      <div className="font-semibold text-xl ">EMPLOYEE SALARY PACKAGE</div>
      <div className="flex flex-col gap-1 overflow-x-scroll pt-10 pl-20 relative -left-16 pb-5">
        <div className="flex gap-1 w-full">
          <span
            style={{ minWidth: "5rem" }}
            className="w-20 flex items-center justify-center  bg-[#FED7AA] text-center break-words"
          >
            SNO
          </span>
          {fixedColumns?.map((item) => (
            <span
              key={item.col}
              style={{ minWidth: "14rem" }}
              className="w-56 flex items-center justify-center bg-[#FED7AA] break-words"
            >
              {item.title?.toUpperCase()}
            </span>
          ))}
          {costSheetHeadings?.map((item, index) => (
            <div
              key={index}
              style={{ minWidth: "14rem" }}
              className="w-60 min-w-56 bg-[#FED7AA] flex items-center text-center break-words relative"
            >
              {item?.default ? (
                <span className="text-center m-auto">
                  {item.rate_category_item_name?.toUpperCase()}
                </span>
              ) : (
                <input
                  type="text"
                  defaultValue={item.rate_category_item_name}
                  onChange={(e) =>
                    updateColumnName(index, e.target.value?.toUpperCase())
                  }
                  placeholder="ENTER TITLE"
                  required
                  className="bg-[#FED7AA] outline-none mx-auto text-center"
                />
              )}
              {!item?.default && (
                <button
                  type="button"
                  className="bg-red text-white p-1 rounded-md ring-1 ring-red absolute right-10 -top-8"
                  onClick={() => deleteColumn(index)}
                >
                  <MdDeleteOutline size={"1.2rem"} />
                </button>
              )}
              {index == costSheetHeadings.length - 2 && (
                <button
                  type="button"
                  className=" p-1 rounded-md ring-1 ring-slate-300 absolute -top-8 right-0 !z-50 "
                  onClick={addNewColumn}
                >
                  <BiPlus size={"1.2rem"} />
                </button>
              )}
            </div>
          ))}
          <span
            key={"total"}
            style={{ minWidth: "14rem" }}
            className="w-56 bg-[#FED7AA] text-center break-words"
          >
            TOTAL MONTHLY CHARGES (SAR)
          </span>
        </div>

        {/* Rows */}
        {fixedColsRows?.map((row, rowIndex) => {
          return (
            <div className="flex gap-1 w-full" key={rowIndex}>
              <span
                style={{ minWidth: "5rem" }}
                className="w-20 flex items-center justify-center  bg-[#E2E8F0] text-center break-words relative"
              >
                {rowIndex + 1}
                {rowIndex === fixedColsRows.length - 1 && (
                  <button
                    type="button"
                    className="p-1 rounded-md ring-1 ring-slate-300 absolute  -left-16"
                    onClick={addNewRow}
                  >
                    <BiPlus size={"1.2rem"} />
                  </button>
                )}
                <button
                  type="button"
                  className="bg-red text-white p-1 rounded-md ring-1 ring-red absolute -left-8"
                  onClick={() => deleteRow(rowIndex)}
                >
                  <MdDeleteOutline size={"1.2rem"} />
                </button>
              </span>
              {fixedColumns?.map((col, cid) => {
                return (
                  <React.Fragment key={cid}>
                    {col?.type === "select" ? (
                      <select
                        className={`bg-slate-200 select select-sm rounded-none focus:outline-none w-56`}
                        required
                        value={row[col.col]}
                        onChange={(e) =>
                          handleUpdateRowProperties(
                            rowIndex,
                            col.col,
                            e.target.value
                          )
                        }
                      >
                        <option value="" hidden>
                          SELECT AN OPTION
                        </option>
                        {col.data?.map((optionData) => (
                          <option value={optionData.id} key={optionData.id}>
                            {optionData.name?.toUpperCase()}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <input
                        defaultValue={row[col.col]}
                        onChange={(e) => {
                          const val =
                            col.col === "quantity"
                              ? e.target.value?.toUpperCase()
                              : e.target.value;
                          handleUpdateRowProperties(
                            rowIndex,
                            col.col,
                            val,
                            true
                          );
                        }}
                        // type='number'
                        type={`${col.col === "quantity" ? "text" : "number"}`}
                        required
                        placeholder="Enter Value"
                        style={{ minWidth: "14rem" }}
                        className="bg-[#E2E8F0] outline-none w-56 text-center "
                      />
                    )}
                  </React.Fragment>
                );
              })}
              {costSheetHeadings?.map((costSheet, costIndex) => {
                return (
                  // <React.Fragment key={costSheet?.rate_category_item_name}>
                  <React.Fragment key={costSheet.costSheetId}>
                    {costIndex === costSheetHeadings?.length -1 ? (
                      <span
                        style={{ minWidth: "14rem" }}
                        className="w-56 flex items-center justify-center  bg-[#E2E8F0] text-center break-words relative"
                      >
                        {costSheetRows[rowIndex][costIndex]?.cost}
                      </span>
                    ) : (
                      <>
                      <input
                        defaultValue={costSheetRows && costSheetRows[rowIndex] && costSheetRows[rowIndex][costIndex]?.cost}
                        onChange={(e) =>
                          updateCostSheetValues(
                            rowIndex,
                            costIndex,
                            e.target.value
                          )
                        }
                        placeholder="Enter Values"
                        required
                        style={{ minWidth: "14rem" }}
                        type="number"
                        className="bg-[#E2E8F0] outline-none w-56 text-center "
                      />
                      </>
                    )}
                  </React.Fragment>
                );
              })}
              <span
                style={{ minWidth: "14rem" }}
                className="w-56 flex items-center justify-center  bg-[#E2E8F0] text-center break-words relative"
              >
                {totMonthlyCharges[rowIndex]}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EmployeeSalaryPackage;

function getIdByName(arr, nameToFind) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].name === nameToFind) {
      return arr[i].id;
    }
  }
  return null;
}

function getMonthlyFee(selectDatas, profession_level_id) {
  if (profession_level_id && selectDatas) {
    const profession_level = selectDatas?.profession_level?.find(
      (item) => item.id == profession_level_id
    );
    const { admin_fee, nitakat, soundline_fee } = profession_level;
    return parseInt(admin_fee) + parseInt(nitakat) + parseInt(soundline_fee);
  } else {
    return 0;
  }
}
